import React from 'react';

// Styles
import './AccountSidebar.scss';

// Comps
import DropdownMenu from '@src/stories/blocks/DropdownMenu/DropdownMenu';

const AccountSidebar = ({ menu, colorSchema }) => {
  return (
    <div className='account-sidebar'>
      <p className='hidden lg:block b2--bold mb-6'>
        Navigation
      </p>

      <DropdownMenu
        links={menu}
        colorSchema={colorSchema}
        hoverAnimation={true}
        disableDesktop={true}
        breakpoint={1024}
      />
    </div>
  );
};

export default AccountSidebar;
